import Background from "./components/Background";
import Button from "../../../../Elements/Button/Button";
import getPurchaseCompleteButtonData from "./helpers/getPurchaseCompleteButtonData";
import HeaderComplete from "./components/HederComplete";
import Image from "../../../../Elements/Image/Image";
import TransactionInfoCard from "../../components/TransactionInfoCard";
import useDowngrade from "../../hooks/useDowngrade";
import useTransaction from "../../hooks/useTransaction";
import { memo, useEffect } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { useParams, useSearchParams } from "react-router-dom";
import { LinkToNewTab } from "../../../../Elements/Link/Link";
import { DowngradeDetailsTypeE } from "../../models/enums";
import { setIsTransactionExecuting } from "../../store/purchasesSlice";
import { useAppDispatch } from "../../../../../store/hooks";
import type { PackageTypeRouteT } from "../../models/models";
import { useUser } from "../../../../../contexts/userContext/userContext";
// @ts-ignore
import config from "../../../../../config";

import styles from "./styles.module.scss";

interface PurchaseCompleteI {
  t?: string; // Transaction Id
  token?: string; // Credit Card token
}

const PurchaseComplete = memo((props: PurchaseCompleteI) => {
  const { t, token } = props;
  const isDowngrade = window.location.pathname.includes("downgrade");
  const { packageType } = useParams<{
    packageType: PackageTypeRouteT;
  }>();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { getTextByKey, getPath } = useContent();
  const { isTokenExist, getUserData } = useUser();
  const { transactionDetails, getTransactionDetails } = useTransaction();
  const { downgradeDetails, setDowngradeDetails } = useDowngrade();
  const isAddon =
    searchParams.get("type") === "sub-users" ||
    searchParams.get("type") === "extra-storage";
  const tParam = t
    ? t
    : searchParams.get("t") !== "undefined"
    ? searchParams.get("t")
    : null;
  const tokenParam = token
    ? token
    : searchParams.get("token") !== "undefined"
    ? searchParams.get("token")
    : null;
  const purchaseCompleteButtonData = getPurchaseCompleteButtonData(
    downgradeDetails?.type!
  );

  useEffect(() => {
    // Redirect to home page if user is not logged in
    if (!isTokenExist) {
      //@ts-ignore
      window.location.href = config.baseurl + getPath() + "home";
    }
  }, [isTokenExist]);

  useEffect(() => {
    if (
      getUserData()?.UserName &&
      transactionDetails?.PurchaseTransactionEmail &&
      getUserData()?.UserName !== transactionDetails?.PurchaseTransactionEmail
    ) {
      //@ts-ignore
      window.location.href = config.baseurl + getPath() + "home";
    }
  }, [getUserData()?.UserName, transactionDetails?.PurchaseTransactionEmail]);

  useEffect(() => {
    if (!window.location.href.includes("error")) {
      if (!isDowngrade) {
        if (tParam && tokenParam) {
          getTransactionDetails({
            t: tParam,
            token: tokenParam,
            billingResponse: JSON.parse(searchParams.get("response")!),
          });
        } else {
          //@ts-ignore
          // window.location.href = config.baseurl + getPath() + "error";
        }
      }
    }
  }, [tParam, tokenParam]);

  useEffect(() => {
    // Check if current url includes error response data
    // and send the message to the parent window
    // (in this case this url opens as an iframe)
    // in order to indicate parent window the purchase is failed.
    if (window.location.href.includes("error")) {
      window.location.href = window.location.href.replace("complete", "failed");
      // window.postMessage("purchase-failed", window.location.origin);
    }
  }, []);

  useEffect(() => {
    if (isDowngrade) {
      setDowngradeDetails(
        isDowngrade!,
        isAddon,
        isAddon ? searchParams.get("type")! : packageType!
      );
    }
  }, [isAddon, isDowngrade, searchParams.get("type")]);

  useEffect(() => {
    dispatch(setIsTransactionExecuting(false));
  }, []);

  return (
    <div className={styles.purchaseCompleteContainer}>
      {transactionDetails || downgradeDetails ? (
        <>
          <div className={styles.transactionInfoCard}>
            <div className={styles.infoHeaderCard}>
              <div className={styles.purchaseCompleteIconDiv}>
                <Image
                  name="purchases/purchase-complete"
                  ext="png"
                  className={styles.purchaseIcon}
                />
              </div>
              <div className={styles.purchaseCompleteTitle}>
                <h1>
                  {downgradeDetails
                    ? isAddon
                      ? getTextByKey("downgrade-addon-update")
                      : getTextByKey("downgrade-plan-update")
                    : getTextByKey("purchase-complete-title")}
                </h1>
              </div>
              <HeaderComplete
                type={
                  (downgradeDetails
                    ? downgradeDetails.displayName
                    : transactionDetails!.PurchaseTransactionProductType.toLocaleLowerCase()) as DowngradeDetailsTypeE
                }
                isDowngrade={isDowngrade!}
                isAddon={isAddon}
                transactionDetails={transactionDetails!}
              />
              {purchaseCompleteButtonData.displayButton ? (
                <div className={styles.purchaseCompleteLink}>
                  {/*TODO: Add types for LinkToNewTab*/}
                  {/*@ts-ignore*/}
                  <LinkToNewTab page={purchaseCompleteButtonData.link} isNewTab>
                    <Button className={styles.newButton}>
                      {getTextByKey(purchaseCompleteButtonData.textKey)}
                    </Button>
                  </LinkToNewTab>
                </div>
              ) : null}
            </div>
            <TransactionInfoCard
              transaction={transactionDetails!}
              downgradeDetails={downgradeDetails!}
            />
          </div>
        </>
      ) : (
        <div className={styles.transactionInfoCard}></div>
      )}
      <Background />
    </div>
  );
});

export default PurchaseComplete;
